export default function printDopCarInfo(info) {
    const mileage = info.mileage ? `${info.mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${info.mileageType}`: '';
    return (
        {
            margin: [0, 0, 0, 10],
            table: {
                headerRows: 1,
                widths: [100, 250, 100],
                body: [
                    [
                        {
                            text: 'Госномер',
                        },
                        {
                            text: 'VIN/Frame',
                        },
                        {
                            text: 'Пробег',
                        },
                    ],
                    [
                        info.plate,
                        info.vin,
                        mileage,
                    ],
                ]
            }
        }
    )
}